/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useReducer } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';

// ============================================
// CRIMSON CHILD - VISUAL BIBLE AESTHETIC
// Dark electronic / Poetic / Abstract
// ============================================

const INITIAL_STATE = {
  user: null,
  cart: [],
  forumPosts: [],
 releases: [
  { id: 1, title: 'FLOATING, FALLING', type: 'EP', year: 2026, tracks: 5, description: 'The Pursuit is my shelter', url: 'https://open.spotify.com/album/5dbv2reFyzrHLU3pY8Tggj?si=9r17ZfbKSImz4pQ3gtZoYQ', image:'https://i.imgur.com/an5HnGe.jpeg'},
  { id: 2, title: 'ELEVENTH HOUR', type: 'LP', year: 2021, tracks: 11, description: 'Debut album launched on Space Yacht Records', url: 'https://open.spotify.com/album/7vmvpygHG8lO0hTaFrKeYI', image: 'https://i.imgur.com/DcM9AAo.jpeg'},
  { id: 3, title: 'FLUME - MONSOON (REMIX)', type: 'Remix', year: 2025, url: 'https://soundcloud.com/officialcrimsonchild/monsoonremix', image: 'https://i.imgur.com/f9C2AtN.jpeg'},
  { id: 4, title: 'LUDWIG GÖRANSSON - CAN YOU HEAR THE MUSIC (REMIX)', type: 'Remix', year: 2024, url: 'https://soundcloud.com/officialcrimsonchild/canyouhear', image: 'https://i.imgur.com/70vKiAm.jpeg'},
  { id: 5, title: 'YOU', type: 'Single', year: 2025, description: 'Collaboration w/ Aspen King & Carmanah King Released on Awakening Compilation Vol. 2', url: 'https://open.spotify.com/album/0bIEPstvoJYgJDx2UXgYkd?si=sEPz0TQ9RyGXWbKoH5qb3Q', image: 'https://i.imgur.com/nmHhS0T.jpeg'},
  { id: 6, title: 'HANS ZIMMER - DUNE (REMIX)', type: 'Remix', year: 2024, url: 'https://soundcloud.com/officialcrimsonchild/dunermx', image: 'https://i.imgur.com/rian9ZN.jpeg'},
  { id: 7, title: 'AD ASTRA VIP', type: 'Remix', year: 2024, url: 'https://soundcloud.com/officialcrimsonchild/adastravip', image: 'https://i.imgur.com/ETxjYpU.jpeg'},
  { id: 8, title: 'THE DARK', type: 'Single', year: 2023, description: 'Monstercat release w/ Whipped Cream & Jasiah', url: 'https://open.spotify.com/album/60XUyh545wo0P4HHuVQPsI?si=PA--VICwQ4-t4PSleaRwHg', image: 'https://i.imgur.com/mVT5JKQ.jpeg'},
  { id: 9, title: 'OUT OF LOVE', type: 'Single', year: 2022, description: 'Collaboration w/ NOTO Released on Westwood Recordings', url: 'https://open.spotify.com/track/0e3pTIZB3B3evlEFHRpnxz?si=91fda4fe04c94538', image: 'https://i.imgur.com/JAfVF7j.jpeg'},
  { id: 10, title: 'INNER GATE', type: 'Single', year: 2021, description: 'Collaboration w/ SUMMONS Released on Crowsnest Audio', url: 'https://open.spotify.com/track/4O6dfNAwP9uCpuAr3UaXGK?si=f029b7c1edc34b3c', image: 'https://i.imgur.com/ZcFSk03.jpeg'},
  { id: 11, title: 'GOD RAYS', type: 'Single', year: 2019, description: 'the song that opened all the doors for me', url: 'https://open.spotify.com/track/4WhRDoVZjKWlAxQfeEU7eB?si=2f65ef48a2c04644', image: 'https://i.imgur.com/oBBMQvC.jpeg'},
],
  videos: [
    { id: 1, title: 'FLOATING, FALLING', year: 2026, duration: '3:58', url: 'https://www.youtube.com/watch?v=AVT-ZmKPLro', thumbnail: 'https://i.imgur.com/MaAS12Y.png' },
    { id: 2, title: 'DRIFTER w/ FRIGID', year: 2025, duration: '3:53', url: 'https://www.youtube.com/watch?v=A1p0Uu9q6WA', thumbnail: 'https://i.imgur.com/cF3dpmS.jpeg' },
    { id: 3, title: 'IS THIS WHAT YOU WANTED (VIP)', year: 2025, duration: '3:30', url: 'https://www.youtube.com/watch?v=hh9YAQgYoDE', thumbnail: 'https://i.imgur.com/ho6jrXG.png' },
  ],
  merchandise: [
    { 
      id: 1, 
      name: 'WILTED ROSE HOODIE', 
      price: 105, 
      category: 'apparel', 
      variants: ['XS', 'S', 'M', 'L', 'XL'], 
      imageBack: 'https://i.imgur.com/OsLWJDU.jpeg',
      imageFront: 'https://i.imgur.com/ZZgklvE.jpeg',
      description: 'Premium Heavyweight Hoodie Featuring Wilted Rose design.',
      fabric: '340 GSM • Cotton Polyester Blend • Generous Fit',
      details: [
        'Premium 340gsm',
        '70/30 Ring Spun Cotton Polyester Blend',
        'Generous Fit',
        'Printed Magnetic Box & UV DTF Tags',
        'Direct to Film Print',
        'Tax Included',
      ],
      care: [
        { icon: '30°', text: 'Machine wash at 30°C (gentle cycle)' },
        { icon: '✕', text: 'Do not bleach' },
        { icon: '◐', text: 'Tumble dry low' },
        { icon: '△', text: 'Iron at low temperature, avoid ironing on print' },
        { icon: '⊘', text: 'Do not dry clean' },
      ],
      sizing: {
        'XS': { 'body length': '27 1/2"' },
        'S': { 'body length': '28 1/2"' },
        'M': { 'body length': '29 1/2"' },
        'L': { 'body length': '30 1/2"' },
        'XL': { 'body length': '31 1/2"' },
      },
      stripeLinks: {
        'XS': 'https://buy.stripe.com/eVq7sL9mI6Fy6lp5sS4c802',
        'S': 'https://buy.stripe.com/bJebJ1dCYd3WeRV8F44c803',
        'M': 'https://buy.stripe.com/8x29ATaqM8NG39d2gG4c804',
        'L': 'https://buy.stripe.com/aFacN57eA7JC6lp6wW4c805',
        'XL': 'https://buy.stripe.com/bJe7sL2Yk4xq2597B04c806',
      },
      priceIds: {
        'XS': 'price_1TBQLOHldC6fYD1lRxapOn7X',
        'S': 'price_1TBQKnHldC6fYD1lRIgCpBda',
        'M': 'price_1TBQK8HldC6fYD1ljJIzfhdu',
        'L': 'price_1TBQJmHldC6fYD1ljchDSyYr',
        'XL': 'price_1TBQJCHldC6fYD1lcg9yzTH7',
      }
    },
    { 
      id: 2, 
      name: 'FLOATING, FALLING TEE', 
      price: 80, 
      category: 'apparel', 
      variants: ['XS', 'S', 'M', 'L', 'XL'], 
      imageBack: 'https://i.imgur.com/yl8smTx.jpeg',
      imageFront: 'https://i.imgur.com/3g3JrcI.jpeg',
      description: 'Limited Edition Tee Celebrating the Floating, Falling EP.',
      fabric: '300 GSM • 100% Cotton • Regular Fit',
      details: [
        'Premium 300gsm',
        '100% Cotton',
        'Regular Fit',
        'Printed Magnetic Box & UV DTF Tags',
        'Direct to Film Print',
        'Tax Included',
      ],
      care: [
        { icon: '30°', text: 'Machine wash at 30°C (gentle cycle)' },
        { icon: '✕', text: 'Do not bleach' },
        { icon: '◐', text: 'Tumble dry low' },
        { icon: '△', text: 'Iron at low temperature, avoid ironing on print' },
        { icon: '⊘', text: 'Do not dry clean' },
      ],
      sizing: {
        'XS': { length: '28.35"', shoulder: '21.54"', chest: '21.85"', sleeve: '9.02"' },
        'S': { length: '29.13"', shoulder: '22.13"', chest: '22.64"', sleeve: '9.21"' },
        'M': { length: '29.92"', shoulder: '22.72"', chest: '23.43"', sleeve: '9.41"' },
        'L': { length: '30.71"', shoulder: '23.43"', chest: '24.41"', sleeve: '9.65"' },
        'XL': { length: '31.50"', shoulder: '24.13"', chest: '25.39"', sleeve: '9.88"' },
      },
      stripeLinks: {
        'XS': 'https://buy.stripe.com/00wdR9dCY6Fy7pt6wW4c807',
        'S': 'https://buy.stripe.com/dRmaEX6aw3tm39d9J84c808',
        'M': 'https://buy.stripe.com/eVq28r1Ug2pidNRaNc4c809',
        'L': 'https://buy.stripe.com/4gM5kDcyUfc4h03dZo4c80a',
        'XL': 'https://buy.stripe.com/00w3cv2YkbZS4dhdZo4c80b',
      },
      priceIds: {
        'XS': 'price_1TBQImHldC6fYD1l77EDdPQG',
        'S': 'price_1TBQISHldC6fYD1la6jVlxIq',
        'M': 'price_1TBQI7HldC6fYD1lXkf3x8WR',
        'L': 'price_1TBQFbHldC6fYD1lA0v2bkWd',
        'XL': 'price_1TBQHlHldC6fYD1l4ZJkHF8g',
      }
    },
    { id: 3, name: 'ELEVENTH HOUR VINYL', price: 35, category: 'music', variants: [], image: 'https://i.imgur.com/DcM9AAo.jpeg', stripeLink: 'https://buy.stripe.com/9B63cv56s0hah039J84c80c', priceId: 'price_1T9iyAHldC6fYD1lDN8AxE4a' },
  ],
  samplePacks: [
   { id: 1, name: 'SOUNDS OF THE ELEVENTH HOUR', description: 'Over 800MB of sounds from the album. Heavyweight basses, punchy kicks, gorgeous piano work, massive drones, and ethereal leads.', price: 40, samples: 200, url: 'https://www.loopmasters.com/genres/144-Bass-Music/products/13676-Crimson-Child-Sounds-Of-The-Eleventh-Hour', image: 'https://i.imgur.com/DcM9AAo.jpeg' },
  ],
  tourDates: [],
  socials: [
    { name: 'INSTAGRAM', handle: '@crimsonchildmusic', url: 'https://instagram.com/crimsonchildmusic' },
    { name: 'FACEBOOK', handle: 'Crimson Child', url: 'https://facebook.com/crimsonchildmusic' },
    { name: 'SPOTIFY', handle: 'Crimson Child', url: 'https://open.spotify.com/artist/3HfDytr1a4fQhrC2J29K6v' },
    { name: 'YOUTUBE', handle: 'Crimson Child', url: 'https://youtube.com/@crimsonchildmusic' },
    { name: 'TWITTER', handle: '@crimsonchild__', url: 'https://x.com/crimsonchild__' },
  ],
};

function reducer(state, action) {
  switch (action.type) {
    case 'ADD_TO_CART':
      return { ...state, cart: [...state.cart, action.payload] };
    case 'REMOVE_FROM_CART':
      return { ...state, cart: state.cart.filter((_, i) => i !== action.payload) };
    case 'UPDATE_QUANTITY':
      return { 
        ...state, 
        cart: state.cart.map((item, i) => 
          i === action.payload.index 
            ? { ...item, quantity: action.payload.quantity } 
            : item
        ) 
      };
    case 'ADD_POST':
      return { ...state, forumPosts: [action.payload, ...state.forumPosts] };
    case 'DELETE_POST':
      return { ...state, forumPosts: state.forumPosts.filter(p => p.id !== action.payload) };
    case 'LOGIN':
      return { ...state, user: action.payload };
    case 'LOGOUT':
      return { ...state, user: null };
    default:
      return state;
  }
}

// ============================================
// GLOBAL STYLES - VISUAL BIBLE AESTHETIC
// ============================================
const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400&family=JetBrains+Mono:wght@400;500;700&display=swap');
  
  :root {
    --crimson: #8B0000;
    --blood: #4A0000;
    --bone: #F5F0E8;
    --ash: #2A2A2A;
    --ink: #0A0A0A;
    --gold: #C9A227;
    --parchment: #E8E0D0;
  }
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: 'Cormorant Garamond', Georgia, serif;
    background: var(--ink);
    color: var(--bone);
    overflow-x: hidden;
  }
  
  ::selection {
    background: var(--crimson);
    color: var(--bone);
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(30px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes fadeInLeft {
    from { opacity: 0; transform: translateX(-40px); }
    to { opacity: 1; transform: translateX(0); }
  }
  
  @keyframes fadeInRight {
    from { opacity: 0; transform: translateX(40px); }
    to { opacity: 1; transform: translateX(0); }
  }
  
  @keyframes fadeInScale {
    from { opacity: 0; transform: scale(0.9); }
    to { opacity: 1; transform: scale(1); }
  }
  
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
`;

// ============================================
// NAVIGATION
// ============================================
function Navigation({ currentPage, setPage, cart, setShowCart }) {
  const [menuOpen, setMenuOpen] = useState(false);
  
  const cartCount = cart.reduce((sum, item) => sum + (item.quantity || 1), 0);
  
  const navItems = [
    { id: 'home', label: 'HOME' },
    { id: 'releases', label: 'RELEASES' },
    { id: 'videos', label: 'VIDEOS' },
    { id: 'tour', label: 'TOUR' },
    { id: 'merch', label: 'MERCH' },
    { id: 'samples', label: 'SAMPLES' },
    { id: 'social', label: 'CONNECT' },
  ];
  
  return (
    <>
      <nav style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: 'var(--ink)',
        borderBottom: '1px solid var(--crimson)',
        padding: '1rem 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
        <div 
          onClick={() => setPage('home')}
          style={{ 
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <span style={{
            fontFamily: 'JetBrains Mono',
            fontSize: '0.8rem',
            letterSpacing: '0.3em',
            color: 'var(--bone)',
          }}>
            CRIMSON CHILD
          </span>
        </div>
        
        <div style={{
          display: 'flex',
          gap: '2rem',
          alignItems: 'center',
        }} className="desktop-nav">
          {navItems.map(item => (
            <button
              key={item.id}
              onClick={() => setPage(item.id)}
              style={{
                background: 'none',
                border: 'none',
                color: currentPage === item.id ? 'var(--crimson)' : 'var(--bone)',
                fontFamily: 'JetBrains Mono',
                fontSize: '0.65rem',
                letterSpacing: '0.2em',
                cursor: 'pointer',
                padding: '0.5rem',
                transition: 'color 0.3s',
              }}
            >
              {item.label}
            </button>
          ))}
          
          {/* Cart Button */}
          <button
            onClick={() => setShowCart(true)}
            style={{
              background: 'none',
              border: '1px solid var(--crimson)',
              color: 'var(--bone)',
              fontFamily: 'JetBrains Mono',
              fontSize: '0.65rem',
              letterSpacing: '0.1em',
              cursor: 'pointer',
              padding: '0.5rem 1rem',
              position: 'relative',
            }}
          >
            CART {cartCount > 0 && `(${cartCount})`}
          </button>
        </div>
        
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          {/* Mobile Cart Button */}
          <button
            onClick={() => setShowCart(true)}
            className="mobile-cart-btn"
            style={{
              display: 'none',
              background: 'none',
              border: '1px solid var(--crimson)',
              color: 'var(--bone)',
              padding: '0.5rem 0.75rem',
              fontFamily: 'JetBrains Mono',
              fontSize: '0.7rem',
              cursor: 'pointer',
            }}
          >
            {cartCount > 0 ? cartCount : '0'}
          </button>
          
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="mobile-menu-btn"
            style={{
              display: 'none',
              background: 'none',
              border: '1px solid var(--crimson)',
              color: 'var(--bone)',
              padding: '0.5rem 1rem',
              fontFamily: 'JetBrains Mono',
              fontSize: '0.7rem',
              cursor: 'pointer',
            }}
          >
            {menuOpen ? 'CLOSE' : 'MENU'}
          </button>
        </div>
      </nav>
      
      {menuOpen && (
        <div style={{
          position: 'fixed',
          top: '70px',
          left: 0,
          right: 0,
          bottom: 0,
          background: 'var(--ink)',
          zIndex: 999,
          padding: '2rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}>
          {navItems.map((item, i) => (
            <button
              key={item.id}
              onClick={() => { setPage(item.id); setMenuOpen(false); }}
              style={{
                background: 'none',
                border: 'none',
                borderBottom: '1px solid var(--ash)',
                color: currentPage === item.id ? 'var(--crimson)' : 'var(--bone)',
                fontFamily: 'JetBrains Mono',
                fontSize: '1rem',
                letterSpacing: '0.2em',
                cursor: 'pointer',
                padding: '1rem 0',
                textAlign: 'left',
                animation: `fadeIn 0.3s ease forwards`,
                animationDelay: `${i * 0.05}s`,
                opacity: 0,
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
      
      <style>{`
        @media (max-width: 1024px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: block !important; }
          .mobile-cart-btn { display: block !important; }
        }
      `}</style>
    </>
  );
}

// ============================================
// CURSOR TRAIL EFFECT
// ============================================
function CursorTrail() {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const [trails, setTrails] = useState(
    Array.from({ length: 4 }, (_, i) => ({ x: 0, y: 0, id: i }))
  );
  
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({ x: e.clientX, y: e.clientY });
      setIsVisible(true);
    };
    
    const handleMouseLeave = () => {
      setIsVisible(false);
    };
    
    const handleMouseEnter = () => {
      setIsVisible(true);
    };
    
    document.addEventListener('mousemove', handleMouseMove);
    document.documentElement.addEventListener('mouseleave', handleMouseLeave);
    document.documentElement.addEventListener('mouseenter', handleMouseEnter);
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.documentElement.removeEventListener('mouseleave', handleMouseLeave);
      document.documentElement.removeEventListener('mouseenter', handleMouseEnter);
    };
  }, []);
  
  useEffect(() => {
    let animationId;
    
    const animate = () => {
      setTrails(prev => {
        return prev.map((trail, index) => {
          const target = index === 0 ? mousePos : prev[index - 1];
          const speed = 0.12 - (index * 0.005);
          return {
            ...trail,
            x: trail.x + (target.x - trail.x) * speed,
            y: trail.y + (target.y - trail.y) * speed,
          };
        });
      });
      animationId = requestAnimationFrame(animate);
    };
    
    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, [mousePos]);
  
  return (
    <>
      <style>{`
        * { cursor: none !important; }
      `}</style>
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: 9999,
        overflow: 'hidden',
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.2s ease',
      }}>
        {/* Trail cursors - rendered first so they're behind */}
        {trails.map((trail, index) => (
          <svg
            key={trail.id}
            style={{
              position: 'absolute',
              left: trail.x,
              top: trail.y,
              width: '24px',
              height: '24px',
              opacity: 0.5 - (index * 0.1),
              transform: `translate(-4px, -2px) scale(${1 - (index * 0.04)})`,
            }}
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="1.5"
          >
            <path d="M5 3 L5 18 L9 14 L13 20 L15 19 L11 13 L17 13 Z" />
          </svg>
        ))}
        
        {/* Main cursor - rendered last so it's on top */}
        <svg
          style={{
            position: 'absolute',
            left: mousePos.x,
            top: mousePos.y,
            width: '28px',
            height: '28px',
            transform: 'translate(-4px, -2px)',
            filter: 'drop-shadow(0 0 4px rgba(139, 0, 0, 0.8))',
          }}
          viewBox="0 0 24 24"
          fill="white"
          stroke="var(--crimson)"
          strokeWidth="1"
        >
          <path d="M5 3 L5 18 L9 14 L13 20 L15 19 L11 13 L17 13 Z" />
        </svg>
      </div>
    </>
  );
}

// ============================================
// HOME PAGE
// ============================================
function HomePage({ setPage, hasLoadedOnce }) {
  const [loaded, setLoaded] = useState(hasLoadedOnce);
  
  useEffect(() => {
    if (!loaded) {
      setTimeout(() => setLoaded(true), 100);
    }
  }, [loaded]);
  
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '70px',
    }}>
      <section style={{
        minHeight: 'calc(100vh - 70px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        padding: '2rem',
        textAlign: 'center',
        background: `
          radial-gradient(circle at 50% 50%, rgba(139, 0, 0, 0.1) 0%, transparent 50%),
          linear-gradient(180deg, var(--ink) 0%, var(--blood) 100%)
        `,
      }}>
        
        <div style={{
          opacity: loaded ? 1 : 0,
          transform: loaded ? 'translateY(0)' : 'translateY(30px)',
          transition: 'all 1s ease 0.5s',
        }}>
          <p style={{
            fontFamily: 'JetBrains Mono',
            fontSize: '0.7rem',
            letterSpacing: '0.5em',
            color: 'var(--gold)',
            marginBottom: '2rem',
          }}>
            CINEMATIC BASS MUSIC
          </p>
          
          <h1 
            style={{
              fontSize: 'clamp(3rem, 15vw, 12rem)',
              fontWeight: 300,
              letterSpacing: '-0.02em',
              lineHeight: 0.9,
              marginBottom: '2rem',
              color: 'var(--bone)',
            }}
          >
            CRIMSON<br/>
            <span style={{ color: 'var(--bone)' }}>CHILD</span>
          </h1>
          
          <p style={{
            fontFamily: 'JetBrains Mono',
            fontSize: '0.65rem',
            letterSpacing: '0.3em',
            color: 'var(--bone)',
            opacity: 0.7,
            maxWidth: '500px',
            margin: '0 auto 3rem',
          }}>
            SIMULATANEOUSLY FAMILIAR & TERRIFYINGLY UNKNOWN
          </p>
          
          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}>
            <button
              onClick={() => setPage('releases')}
              style={{
                background: 'var(--crimson)',
                border: 'none',
                color: 'var(--bone)',
                padding: '1rem 2rem',
                fontFamily: 'JetBrains Mono',
                fontSize: '0.7rem',
                letterSpacing: '0.2em',
                cursor: 'pointer',
                transition: 'all 0.3s',
              }}
              onMouseOver={e => e.target.style.background = 'var(--blood)'}
              onMouseOut={e => e.target.style.background = 'var(--crimson)'}
            >
              LISTEN
            </button>
            <button
              onClick={() => setPage('videos')}
              style={{
                background: 'transparent',
                border: '1px solid var(--bone)',
                color: 'var(--bone)',
                padding: '1rem 2rem',
                fontFamily: 'JetBrains Mono',
                fontSize: '0.7rem',
                letterSpacing: '0.2em',
                cursor: 'pointer',
                transition: 'all 0.3s',
              }}
              onMouseOver={e => { e.target.style.background = 'var(--bone)'; e.target.style.color = 'var(--ink)'; }}
              onMouseOut={e => { e.target.style.background = 'transparent'; e.target.style.color = 'var(--bone)'; }}
            >
              WATCH
            </button>
          </div>
        </div>
      </section>
      
      {/* Latest Release */}
      <section style={{
        padding: '6rem 2rem',
        background: 'var(--ink)',
        borderTop: '1px solid var(--ash)',
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            marginBottom: '3rem',
          }}>
            <span style={{
              fontFamily: 'JetBrains Mono',
              fontSize: '0.6rem',
              color: 'var(--gold)',
            }}>001</span>
            <div style={{ flex: 1, height: '1px', background: 'var(--ash)' }} />
            <span style={{
              fontFamily: 'JetBrains Mono',
              fontSize: '0.6rem',
              color: 'var(--bone)',
              opacity: 0.5,
            }}>LATEST</span>
          </div>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '4rem',
            alignItems: 'center',
          }}>
            <div style={{
              aspectRatio: '1',
              background: `url(https://i.imgur.com/an5HnGe.jpeg) center/cover`,
              border: '1px solid var(--crimson)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
            }}>           
              <div style={{
                position: 'absolute',
                top: '1rem',
                left: '1rem',
                fontFamily: 'JetBrains Mono',
                fontSize: '0.5rem',
                color: 'var(--gold)',
              }}>EP • 2026</div>
            </div>
            
            <div>
              <h2 style={{
                fontSize: '3rem',
                fontWeight: 300,
                marginBottom: '1rem',
                letterSpacing: '-0.02em',
              }}>
                FLOATING, FALLING
              </h2>
              <p style={{
                fontFamily: 'JetBrains Mono',
                fontSize: '0.7rem',
                letterSpacing: '0.1em',
                color: 'var(--gold)',
                marginBottom: '1.5rem',
              }}>
                EP • 5 TRACKS
              </p>
              <p style={{
                fontSize: '1.1rem',
                lineHeight: 1.8,
                color: 'var(--parchment)',
                marginBottom: '2rem',
                fontStyle: 'italic',
              }}>
                "To fall is to seek. The pursuit is my shelter"
              </p>
              <button
                onClick={() => window.open('https://open.spotify.com/album/5dbv2reFyzrHLU3pY8Tggj?si=BYxU0rSiT2e2u3PLFs-ZWg', '_blank')}
                style={{
                  background: 'transparent',
                  border: '1px solid var(--crimson)',
                  color: 'var(--crimson)',
                  padding: '1rem 2rem',
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.7rem',
                  letterSpacing: '0.2em',
                  cursor: 'pointer',
                  transition: 'all 0.3s',
                }}
                onMouseOver={e => { e.target.style.background = 'var(--crimson)'; e.target.style.color = 'var(--bone)'; }}
                onMouseOut={e => { e.target.style.background = 'transparent'; e.target.style.color = 'var(--crimson)'; }}
              >
                STREAM NOW
              </button>
            </div>
          </div>
        </div>
      </section>
      
      {/* Merch Section */}
      <section 
        className="home-nav-section"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          background: 'var(--ink)',
          borderTop: '1px solid var(--ash)',
          transition: 'background 0.6s ease',
        }}
      >
        <div
          onClick={() => setPage('merch')}
          className="home-nav-btn"
          style={{
            border: '1px solid var(--ash)',
            padding: '2rem 4rem',
            cursor: 'pointer',
            transition: 'all 0.4s ease',
            textAlign: 'center',
            position: 'relative',
            zIndex: 1,
          }}
          onMouseOver={e => {
            e.currentTarget.style.borderColor = 'var(--crimson)';
            e.currentTarget.style.background = 'var(--blood)';
            e.currentTarget.style.boxShadow = '0 0 80px rgba(139, 0, 0, 0.6), 0 0 120px rgba(139, 0, 0, 0.4), 0 0 200px rgba(139, 0, 0, 0.2)';
            e.currentTarget.parentElement.style.background = 'radial-gradient(circle at center, rgba(139, 0, 0, 0.15) 0%, var(--ink) 70%)';
          }}
          onMouseOut={e => {
            e.currentTarget.style.borderColor = 'var(--ash)';
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.boxShadow = 'none';
            e.currentTarget.parentElement.style.background = 'var(--ink)';
          }}
        >
          <h2 style={{
            fontSize: 'clamp(2rem, 8vw, 5rem)',
            fontWeight: 300,
            letterSpacing: '-0.02em',
          }}>MERCH</h2>
        </div>
        <p style={{
          fontFamily: 'JetBrains Mono',
          fontSize: '0.6rem',
          letterSpacing: '0.3em',
          color: 'var(--bone)',
          opacity: 0.5,
          marginTop: '2rem',
        }}>LIMITED EDITION APPAREL</p>
      </section>
      
      {/* Samples Section */}
      <section 
        className="home-nav-section"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          background: 'var(--ink)',
          borderTop: '1px solid var(--ash)',
          transition: 'background 0.6s ease',
        }}
      >
        <div
          onClick={() => setPage('samples')}
          className="home-nav-btn"
          style={{
            border: '1px solid var(--ash)',
            padding: '2rem 4rem',
            cursor: 'pointer',
            transition: 'all 0.4s ease',
            textAlign: 'center',
            position: 'relative',
            zIndex: 1,
          }}
          onMouseOver={e => {
            e.currentTarget.style.borderColor = 'var(--crimson)';
            e.currentTarget.style.background = 'var(--blood)';
            e.currentTarget.style.boxShadow = '0 0 80px rgba(139, 0, 0, 0.6), 0 0 120px rgba(139, 0, 0, 0.4), 0 0 200px rgba(139, 0, 0, 0.2)';
            e.currentTarget.parentElement.style.background = 'radial-gradient(circle at center, rgba(139, 0, 0, 0.15) 0%, var(--ink) 70%)';
          }}
          onMouseOut={e => {
            e.currentTarget.style.borderColor = 'var(--ash)';
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.boxShadow = 'none';
            e.currentTarget.parentElement.style.background = 'var(--ink)';
          }}
        >
          <h2 style={{
            fontSize: 'clamp(2rem, 8vw, 5rem)',
            fontWeight: 300,
            letterSpacing: '-0.02em',
          }}>SAMPLES</h2>
        </div>
        <p style={{
          fontFamily: 'JetBrains Mono',
          fontSize: '0.6rem',
          letterSpacing: '0.3em',
          color: 'var(--bone)',
          opacity: 0.5,
          marginTop: '2rem',
        }}>PRODUCTION TOOLS</p>
      </section>
      
      {/* Tour Section */}
      <section 
        className="home-nav-section"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          background: 'var(--ink)',
          borderTop: '1px solid var(--ash)',
          transition: 'background 0.6s ease',
        }}
      >
        <div
          onClick={() => setPage('tour')}
          className="home-nav-btn"
          style={{
            border: '1px solid var(--ash)',
            padding: '2rem 4rem',
            cursor: 'pointer',
            transition: 'all 0.4s ease',
            textAlign: 'center',
            position: 'relative',
            zIndex: 1,
          }}
          onMouseOver={e => {
            e.currentTarget.style.borderColor = 'var(--crimson)';
            e.currentTarget.style.background = 'var(--blood)';
            e.currentTarget.style.boxShadow = '0 0 80px rgba(139, 0, 0, 0.6), 0 0 120px rgba(139, 0, 0, 0.4), 0 0 200px rgba(139, 0, 0, 0.2)';
            e.currentTarget.parentElement.style.background = 'radial-gradient(circle at center, rgba(139, 0, 0, 0.15) 0%, var(--ink) 70%)';
          }}
          onMouseOut={e => {
            e.currentTarget.style.borderColor = 'var(--ash)';
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.boxShadow = 'none';
            e.currentTarget.parentElement.style.background = 'var(--ink)';
          }}
        >
          <h2 style={{
            fontSize: 'clamp(2rem, 8vw, 5rem)',
            fontWeight: 300,
            letterSpacing: '-0.02em',
          }}>TOUR</h2>
        </div>
        <p style={{
          fontFamily: 'JetBrains Mono',
          fontSize: '0.6rem',
          letterSpacing: '0.3em',
          color: 'var(--bone)',
          opacity: 0.5,
          marginTop: '2rem',
        }}>LIVE SHOWS</p>
      </section>
      
      {/* Connect Section */}
      <section 
        className="home-nav-section"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          background: 'var(--ink)',
          borderTop: '1px solid var(--ash)',
          transition: 'background 0.6s ease',
        }}
      >
        <div
          onClick={() => setPage('social')}
          className="home-nav-btn"
          style={{
            border: '1px solid var(--ash)',
            padding: '2rem 4rem',
            cursor: 'pointer',
            transition: 'all 0.4s ease',
            textAlign: 'center',
            position: 'relative',
            zIndex: 1,
          }}
          onMouseOver={e => {
            e.currentTarget.style.borderColor = 'var(--crimson)';
            e.currentTarget.style.background = 'var(--blood)';
            e.currentTarget.style.boxShadow = '0 0 80px rgba(139, 0, 0, 0.6), 0 0 120px rgba(139, 0, 0, 0.4), 0 0 200px rgba(139, 0, 0, 0.2)';
            e.currentTarget.parentElement.style.background = 'radial-gradient(circle at center, rgba(139, 0, 0, 0.15) 0%, var(--ink) 70%)';
          }}
          onMouseOut={e => {
            e.currentTarget.style.borderColor = 'var(--ash)';
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.boxShadow = 'none';
            e.currentTarget.parentElement.style.background = 'var(--ink)';
          }}
        >
          <h2 style={{
            fontSize: 'clamp(2rem, 8vw, 5rem)',
            fontWeight: 300,
            letterSpacing: '-0.02em',
          }}>CONNECT</h2>
        </div>
        <p style={{
          fontFamily: 'JetBrains Mono',
          fontSize: '0.6rem',
          letterSpacing: '0.3em',
          color: 'var(--bone)',
          opacity: 0.5,
          marginTop: '2rem',
        }}>FOLLOW THE JOURNEY</p>
      </section>
      
      {/* Quote Section - moved to bottom */}
      <section style={{
        padding: '8rem 2rem',
        background: 'var(--blood)',
        textAlign: 'center',
      }}>
        <blockquote style={{
          fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
          fontStyle: 'italic',
          fontWeight: 300,
          maxWidth: '800px',
          margin: '0 auto',
          lineHeight: 1.6,
        }}>
          To wilt is not to die
        </blockquote>
      </section>
    </div>
  );
}

// ============================================
// RELEASES PAGE
// ============================================
function ReleasesPage({ releases }) {
  const [filter, setFilter] = useState('all');
  
  const filtered = filter === 'all' 
    ? releases 
    : releases.filter(r => r.type.toLowerCase() === filter.toLowerCase());
  
  return (
    <div style={{
      minHeight: '100vh',
      paddingTop: '100px',
      padding: '100px 2rem 4rem',
      maxWidth: '1400px',
      margin: '0 auto',
    }}>
      <header style={{ marginBottom: '4rem' }}>
        <h1 style={{
          fontSize: 'clamp(2rem, 8vw, 5rem)',
          fontWeight: 300,
          letterSpacing: '-0.02em',
          marginBottom: '1rem',
        }}>
          RELEASES
        </h1>
        <p style={{
          fontFamily: 'JetBrains Mono',
          fontSize: '0.7rem',
          letterSpacing: '0.2em',
          color: 'var(--bone)',
          opacity: 0.7,
        }}>
          DISCOGRAPHY
        </p>
      </header>
      
      <div style={{
        display: 'flex',
        gap: '1rem',
        marginBottom: '3rem',
        flexWrap: 'wrap',
      }}>
        {['all', 'LP', 'EP', 'Single', 'Remix'].map(f => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            style={{
              background: filter === f ? 'var(--crimson)' : 'transparent',
              border: '1px solid var(--crimson)',
              color: filter === f ? 'var(--bone)' : 'var(--crimson)',
              padding: '0.5rem 1.5rem',
              fontFamily: 'JetBrains Mono',
              fontSize: '0.6rem',
              letterSpacing: '0.2em',
              cursor: 'pointer',
              textTransform: 'uppercase',
            }}
          >
            {f}
          </button>
        ))}
      </div>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '2rem',
      }}>
       {filtered.map((release, i) => (
        <a
          key={release.id}
          href={release.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            background: 'var(--ash)',
            border: '1px solid transparent',
            transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
            animation: `fadeInScale 0.8s ease forwards`,
            animationDelay: `${i * 0.15}s`,
            opacity: 0,
            cursor: 'pointer',
            textDecoration: 'none',
            color: 'var(--bone)',
            overflow: 'hidden',
          }}
          onMouseOver={e => {
            e.currentTarget.style.borderColor = 'var(--crimson)';
            e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
            e.currentTarget.style.boxShadow = '0 20px 40px rgba(139, 0, 0, 0.3), 0 0 60px rgba(139, 0, 0, 0.1)';
            const img = e.currentTarget.querySelector('.card-image');
            if (img) img.style.transform = 'scale(1.1)';
          }}
          onMouseOut={e => {
            e.currentTarget.style.borderColor = 'transparent';
            e.currentTarget.style.transform = 'translateY(0) scale(1)';
            e.currentTarget.style.boxShadow = 'none';
            const img = e.currentTarget.querySelector('.card-image');
            if (img) img.style.transform = 'scale(1)';
          }}
          >
            <div 
              className="card-image"
              style={{
                aspectRatio: '1',
                background: release.image ? `url(${release.image}) center/cover` : `linear-gradient(${135 + i * 45}deg, var(--blood) 0%, var(--ink) 100%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                transition: 'transform 0.4s ease',
              }}>
              <div style={{
                position: 'absolute',
                bottom: '1rem',
                right: '1rem',
                fontFamily: 'JetBrains Mono',
                fontSize: '0.5rem',
                color: 'var(--gold)',
              }}>{release.type}</div>
            </div>
            <div style={{ padding: '1.5rem' }}>
              <h3 style={{
                fontSize: '1.2rem',
                fontWeight: 400,
                marginBottom: '0.5rem',
              }}>{release.title}</h3>
              <p style={{
                fontFamily: 'JetBrains Mono',
                fontSize: '0.6rem',
                color: 'var(--bone)',
                opacity: 0.6,
                marginBottom: '0.5rem',
              }}>
                {release.year} • {release.tracks} TRACK{release.tracks > 1 ? 'S' : ''}
              </p>
              <p style={{
                fontSize: '0.85rem',
                color: 'var(--parchment)',
                opacity: 0.7,
                fontStyle: 'italic',
              }}>{release.description}</p>
            </div>
          </a>
        ))}
      </div>
      
      <div style={{
        marginTop: '4rem',
        padding: '2rem',
        border: '1px solid var(--ash)',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
      }}>
        <div style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          background: '#00ff00',
          animation: 'pulse 2s ease infinite',
        }} />
        <span style={{
          fontFamily: 'JetBrains Mono',
          fontSize: '0.6rem',
          letterSpacing: '0.2em',
        }}>
          AVAILABLE ON SPOTIFY • APPLE MUSIC • SOUNDCLOUD • BANDCAMP
        </span>
      </div>
    </div>
  );
}

// ============================================
// VIDEOS PAGE
// ============================================
function VideosPage({ videos }) {
  return (
    <div style={{
      minHeight: '100vh',
      paddingTop: '100px',
      padding: '100px 2rem 4rem',
      maxWidth: '1400px',
      margin: '0 auto',
    }}>
      <header style={{ marginBottom: '4rem' }}>
        <h1 style={{
          fontSize: 'clamp(2rem, 8vw, 5rem)',
          fontWeight: 300,
          letterSpacing: '-0.02em',
          marginBottom: '1rem',
        }}>
          VIDEOS
        </h1>
        <p style={{
          fontFamily: 'JetBrains Mono',
          fontSize: '0.7rem',
          letterSpacing: '0.2em',
          color: 'var(--bone)',
          opacity: 0.7,
        }}>
          MUSIC VIDEOS
        </p>
      </header>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
        gap: '2rem',
      }}>
        {videos.map((video, i) => (
          <a
            key={video.id}
            href={video.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: 'none',
              color: 'var(--bone)',
              animation: `fadeInScale 0.8s ease forwards`,
              animationDelay: `${i * 0.2}s`,
              opacity: 0,
              transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
            }}
            onMouseOver={e => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              const img = e.currentTarget.querySelector('.video-thumbnail');
              if (img) {
                img.style.borderColor = 'var(--crimson)';
                img.style.boxShadow = '0 20px 40px rgba(139, 0, 0, 0.3)';
                img.style.transform = 'scale(1.02)';
              }
            }}
            onMouseOut={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              const img = e.currentTarget.querySelector('.video-thumbnail');
              if (img) {
                img.style.borderColor = 'var(--ash)';
                img.style.boxShadow = 'none';
                img.style.transform = 'scale(1)';
              }
            }}
          >
            <div 
              className="video-thumbnail"
              style={{
                aspectRatio: '16/9',
                background: video.thumbnail ? `url(${video.thumbnail}) center/cover` : `linear-gradient(${180 + i * 30}deg, var(--ash) 0%, var(--ink) 100%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                marginBottom: '1rem',
                border: '1px solid var(--ash)',
                transition: 'all 0.4s ease',
                overflow: 'hidden',
              }}
            >
              <div style={{
                position: 'absolute',
                bottom: '0.75rem',
                right: '0.75rem',
                fontFamily: 'JetBrains Mono',
                fontSize: '0.5rem',
                background: 'var(--ink)',
                padding: '0.25rem 0.5rem',
              }}>{video.duration}</div>
            </div>
            <h3 style={{
              fontSize: '1.1rem',
              fontWeight: 400,
              marginBottom: '0.25rem',
            }}>{video.title}</h3>
            {video.artist && (
              <p style={{
                fontFamily: 'JetBrains Mono',
                fontSize: '0.55rem',
                color: 'var(--gold)',
                marginBottom: '0.25rem',
              }}>{video.artist}</p>
            )}
            <p style={{
              fontFamily: 'JetBrains Mono',
              fontSize: '0.55rem',
              color: 'var(--bone)',
              opacity: 0.6,
            }}>{video.year}</p>
          </a>
        ))}
      </div>
    </div>
  );
}

// ============================================
// TOUR PAGE
// ============================================
function TourPage({ tourDates }) {
  return (
    <div style={{
      minHeight: '100vh',
      paddingTop: '100px',
      padding: '100px 2rem 4rem',
      maxWidth: '1200px',
      margin: '0 auto',
    }}>
      <header style={{ marginBottom: '4rem' }}>
        <h1 style={{
          fontSize: 'clamp(2rem, 8vw, 5rem)',
          fontWeight: 300,
          letterSpacing: '-0.02em',
          marginBottom: '1rem',
        }}>
          TOUR
        </h1>
        <p style={{
          fontFamily: 'JetBrains Mono',
          fontSize: '0.7rem',
          letterSpacing: '0.2em',
          color: 'var(--bone)',
          opacity: 0.7,
        }}>
          LIVE DATES
        </p>
      </header>
      
      {/* Upcoming Shows Section */}
      <section style={{ marginBottom: '4rem' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          marginBottom: '2rem',
        }}>
          <span style={{ fontFamily: 'JetBrains Mono', fontSize: '0.6rem', color: 'var(--gold)' }}>UPCOMING</span>
          <div style={{ flex: 1, height: '1px', background: 'var(--ash)' }} />
        </div>
        
        {tourDates.length === 0 ? (
          <div style={{
            padding: '4rem',
            border: '1px dashed var(--ash)',
            textAlign: 'center',
          }}>
            <p style={{
              fontSize: '1.5rem',
              fontStyle: 'italic',
              color: 'var(--parchment)',
              marginBottom: '1rem',
            }}>No upcoming dates</p>
            <p style={{
              fontFamily: 'JetBrains Mono',
              fontSize: '0.65rem',
              color: 'var(--bone)',
              opacity: 0.6,
            }}>FOLLOW FOR ANNOUNCEMENTS</p>
          </div>
        ) : (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1px',
            background: 'var(--ash)',
          }}>
            {tourDates.map((show, i) => {
              const date = new Date(show.date);
              const month = date.toLocaleDateString('en-US', { month: 'short' }).toUpperCase();
              const day = date.getDate();
              
              return (
                <article
                  key={show.id}
                  style={{
                    background: 'var(--ink)',
                    padding: '2rem',
                    display: 'grid',
                    gridTemplateColumns: '80px 1fr auto',
                    gap: '2rem',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      fontFamily: 'JetBrains Mono',
                      fontSize: '0.6rem',
                      color: 'var(--gold)',
                      marginBottom: '0.25rem',
                    }}>{month}</div>
                    <div style={{
                      fontSize: '2.5rem',
                      fontWeight: 300,
                      lineHeight: 1,
                    }}>{day}</div>
                  </div>
                  
                  <div>
                    <h3 style={{ fontSize: '1.3rem', fontWeight: 400, marginBottom: '0.25rem' }}>{show.city}</h3>
                    <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.6rem', color: 'var(--bone)', opacity: 0.6 }}>{show.venue}</p>
                  </div>
                  
                  <button style={{
                    background: show.status === 'sold-out' ? 'var(--ash)' : 'var(--crimson)',
                    border: 'none',
                    color: 'var(--bone)',
                    padding: '0.75rem 1.5rem',
                    fontFamily: 'JetBrains Mono',
                    fontSize: '0.6rem',
                    cursor: show.status === 'sold-out' ? 'not-allowed' : 'pointer',
                  }}>
                    {show.status === 'sold-out' ? 'SOLD OUT' : 'TICKETS'}
                  </button>
                </article>
              );
            })}
          </div>
        )}
      </section>
      
      {/* Instagram Feed */}
      <section>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          marginBottom: '2rem',
        }}>
          <span style={{ fontFamily: 'JetBrains Mono', fontSize: '0.6rem', color: 'var(--gold)' }}>INSTAGRAM</span>
          <div style={{ flex: 1, height: '1px', background: 'var(--ash)' }} />
        </div>
        
        <a 
          href="https://www.instagram.com/crimsonchildmusic/" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            display: 'block',
            padding: '3rem',
            border: '1px solid var(--ash)',
            textAlign: 'center',
            textDecoration: 'none',
            color: 'var(--bone)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={e => {
            e.currentTarget.style.borderColor = 'var(--crimson)';
            e.currentTarget.style.background = 'var(--blood)';
          }}
          onMouseOut={e => {
            e.currentTarget.style.borderColor = 'var(--ash)';
            e.currentTarget.style.background = 'transparent';
          }}
        >
          <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>◐</div>
          <h3 style={{ fontFamily: 'JetBrains Mono', fontSize: '0.8rem', letterSpacing: '0.2em', marginBottom: '0.5rem' }}>
            @CRIMSONCHILDMUSIC
          </h3>
          <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.6rem', color: 'var(--crimson)' }}>
            STAY UP TO DATE →
          </p>
        </a>
      </section>
    </div>
  );
}

// ============================================
// MERCHANDISE PAGE
// ============================================
function MerchPage({ merchandise, dispatch, cart }) {
  const [selectedVariants, setSelectedVariants] = useState({});
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [zoomPos, setZoomPos] = useState({ x: 0, y: 0, show: false, image: null });
  
  const addToCart = (item) => {
    const variant = selectedVariants[item.id] || item.variants[0];
    if (!variant) return;
    dispatch({
      type: 'ADD_TO_CART',
      payload: { ...item, variant }
    });
  };
  
  // Product Detail View
  if (selectedProduct) {
    const item = selectedProduct;
    const hasApparel = item.imageFront && item.imageBack;
    
    const handleMouseMove = (e, image) => {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      setZoomPos({ x, y, show: true, image });
    };
    
    const handleMouseLeave = () => {
      setZoomPos({ ...zoomPos, show: false });
    };
    
    return (
      <div style={{
        minHeight: '100vh',
        paddingTop: '100px',
        padding: '100px 2rem 4rem',
        maxWidth: '1200px',
        margin: '0 auto',
      }}>
        {/* Back Button */}
        <button
          onClick={() => setSelectedProduct(null)}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--bone)',
            fontFamily: 'JetBrains Mono',
            fontSize: '0.7rem',
            cursor: 'pointer',
            marginBottom: '2rem',
            opacity: 0.7,
          }}
        >
          ← BACK TO MERCH
        </button>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '4rem',
        }}>
          {/* Images Section */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {hasApparel ? (
              <>
                {/* Back Image */}
                <div
                  style={{
                    aspectRatio: '1',
                    background: `url(${item.imageBack}) center/cover`,
                    position: 'relative',
                    cursor: 'crosshair',
                    border: '1px solid var(--ash)',
                  }}
                  onMouseMove={(e) => handleMouseMove(e, item.imageBack)}
                  onMouseLeave={handleMouseLeave}
                >
                  <span style={{
                    position: 'absolute',
                    bottom: '1rem',
                    left: '1rem',
                    fontFamily: 'JetBrains Mono',
                    fontSize: '0.5rem',
                    background: 'var(--ink)',
                    padding: '0.25rem 0.5rem',
                    color: 'var(--gold)',
                  }}>BACK</span>
                </div>
                
                {/* Front Image */}
                <div
                  style={{
                    aspectRatio: '1',
                    background: `url(${item.imageFront}) center/cover`,
                    position: 'relative',
                    cursor: 'crosshair',
                    border: '1px solid var(--ash)',
                  }}
                  onMouseMove={(e) => handleMouseMove(e, item.imageFront)}
                  onMouseLeave={handleMouseLeave}
                >
                  <span style={{
                    position: 'absolute',
                    bottom: '1rem',
                    left: '1rem',
                    fontFamily: 'JetBrains Mono',
                    fontSize: '0.5rem',
                    background: 'var(--ink)',
                    padding: '0.25rem 0.5rem',
                    color: 'var(--gold)',
                  }}>FRONT</span>
                </div>
              </>
            ) : (
              <div style={{
                aspectRatio: '1',
                background: item.image ? `url(${item.image}) center/cover` : 'var(--ash)',
                border: '1px solid var(--ash)',
              }} />
            )}
          </div>
          
          {/* Product Info Section */}
          <div>
            <h1 style={{
              fontSize: '2rem',
              fontWeight: 300,
              marginBottom: '0.5rem',
              fontFamily: 'JetBrains Mono',
            }}>{item.name}</h1>
            
            <p style={{
              fontSize: '1.5rem',
              color: 'var(--gold)',
              marginBottom: '2rem',
            }}>${item.price} USD</p>
            
            {item.description && (
              <p style={{
                fontSize: '1rem',
                color: 'var(--parchment)',
                marginBottom: '2rem',
                lineHeight: 1.6,
              }}>{item.description}</p>
            )}
            
            {/* Size Selection Dropdown */}
            {item.variants && item.variants.length > 0 && item.category === 'apparel' && (
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{
                  display: 'block',
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.6rem',
                  color: 'var(--bone)',
                  opacity: 0.7,
                  marginBottom: '0.5rem',
                }}>
                  {item.category === 'apparel' ? 'SELECT SIZE' : 'SELECT VARIANT'}
                </label>
                <select
                  value={selectedVariants[item.id] || item.variants[0]}
                  onChange={(e) => setSelectedVariants({...selectedVariants, [item.id]: e.target.value})}
                  style={{
                    width: '100%',
                    padding: '1rem',
                    background: 'var(--ink)',
                    border: '1px solid var(--crimson)',
                    color: 'var(--bone)',
                    fontFamily: 'JetBrains Mono',
                    fontSize: '0.8rem',
                    cursor: 'pointer',
                  }}
                >
                  {item.variants.map(v => (
                    <option key={v} value={v}>{v}</option>
                  ))}
                </select>
              </div>
            )}
            
            {/* Add to Cart Button */}
            {(item.priceIds || item.priceId) && (
              <button
                onClick={() => {
                  const selectedSize = selectedVariants[item.id] || (item.variants && item.variants[0]) || null;
                  const priceId = item.priceId || (item.priceIds && item.priceIds[selectedSize]);
                  if (priceId) {
                    dispatch({
                      type: 'ADD_TO_CART',
                      payload: {
                        id: item.id,
                        name: item.name,
                        price: item.price,
                        size: selectedSize,
                        priceId: priceId,
                        image: item.imageBack || item.image,
                      }
                    });
                    alert(`${item.name}${selectedSize ? ` (${selectedSize})` : ''} added to cart!`);
                  }
                }}
                style={{
                  width: '100%',
                  background: 'var(--crimson)',
                  border: 'none',
                  color: 'var(--bone)',
                  padding: '1rem',
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.8rem',
                  cursor: 'pointer',
                  marginBottom: '0.75rem',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={e => e.currentTarget.style.background = 'var(--blood)'}
                onMouseOut={e => e.currentTarget.style.background = 'var(--crimson)'}
              >
                ADD TO CART — ${item.price} USD
              </button>
            )}
            
            {(item.priceIds || item.priceId) && (
              <p style={{
                fontFamily: 'JetBrains Mono',
                fontSize: '0.55rem',
                color: 'var(--bone)',
                opacity: 0.5,
                textAlign: 'center',
                marginBottom: '1rem',
              }}>
                CANADA & USA SHIPPING
              </p>
            )}
            
            {/* International Shipping Quote */}
            {(item.priceIds || item.priceId) && (
              <button
                onClick={() => {
                  const selectedSize = selectedVariants[item.id] || item.variants[0];
                  const subject = encodeURIComponent(`International Shipping Quote - ${item.name} (${selectedSize})`);
                  const body = encodeURIComponent(`Hi,\n\nI'd like to order:\n\nItem: ${item.name}\nSize: ${selectedSize}\nCountry: [YOUR COUNTRY]\n\nPlease send me a shipping quote.\n\nThank you!`);
                  window.location.href = `mailto:crimsonchildpromo@gmail.com?subject=${subject}&body=${body}`;
                }}
                style={{
                  width: '100%',
                  background: 'transparent',
                  border: '1px solid var(--bone)',
                  color: 'var(--bone)',
                  padding: '1rem',
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.7rem',
                  cursor: 'pointer',
                  marginBottom: '0.5rem',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={e => { e.currentTarget.style.background = 'var(--bone)'; e.currentTarget.style.color = 'var(--ink)'; }}
                onMouseOut={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--bone)'; }}
              >
                INTERNATIONAL? REQUEST QUOTE
              </button>
            )}
            
            {(item.priceIds || item.priceId) && (
              <p style={{
                fontFamily: 'JetBrains Mono',
                fontSize: '0.55rem',
                color: 'var(--bone)',
                opacity: 0.5,
                textAlign: 'center',
                marginBottom: '2rem',
              }}>
                EU • UK • ASIA • AUSTRALIA • WORLDWIDE
              </p>
            )}
            
            {/* Product Details */}
            {item.details && (
              <div style={{ marginBottom: '2rem' }}>
                <h4 style={{
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.7rem',
                  color: 'var(--gold)',
                  marginBottom: '1rem',
                }}>DETAILS</h4>
                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                }}>
                  {item.details.map((detail, idx) => (
                    <li key={idx} style={{
                      fontSize: '0.9rem',
                      color: 'var(--parchment)',
                      marginBottom: '0.5rem',
                      paddingLeft: '1rem',
                      borderLeft: '1px solid var(--ash)',
                    }}>{detail}</li>
                  ))}
                </ul>
              </div>
            )}
            
            {/* Fabric Info */}
            {item.fabric && (
              <div style={{ 
                marginBottom: '2rem',
                padding: '1rem',
                background: 'var(--ink)',
                border: '1px solid var(--ash)',
              }}>
                <p style={{
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.75rem',
                  color: 'var(--bone)',
                  letterSpacing: '0.1em',
                }}>{item.fabric}</p>
              </div>
            )}
            
            {/* Care Instructions */}
            {item.care && Array.isArray(item.care) && (
              <div style={{ marginBottom: '2rem' }}>
                <h4 style={{
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.7rem',
                  color: 'var(--gold)',
                  marginBottom: '1rem',
                }}>CARE INSTRUCTIONS</h4>
                <div style={{
                  display: 'grid',
                  gap: '0.75rem',
                }}>
                  {item.care.map((instruction, idx) => (
                    <div key={idx} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1rem',
                    }}>
                      <div style={{
                        width: '36px',
                        height: '36px',
                        border: '1px solid var(--ash)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontFamily: 'JetBrains Mono',
                        fontSize: '0.7rem',
                        color: 'var(--bone)',
                        flexShrink: 0,
                      }}>{instruction.icon}</div>
                      <p style={{
                        fontSize: '0.85rem',
                        color: 'var(--parchment)',
                      }}>{instruction.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            {/* Size Guide */}
            {item.sizing && (
              <div>
                <h4 style={{
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.7rem',
                  color: 'var(--gold)',
                  marginBottom: '1rem',
                }}>SIZE GUIDE</h4>
                <div style={{
                  overflowX: 'auto',
                }}>
                  <table style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    fontFamily: 'JetBrains Mono',
                    fontSize: '0.7rem',
                  }}>
                    <thead>
                      <tr>
                        <th style={{ padding: '0.75rem', borderBottom: '1px solid var(--ash)', textAlign: 'left', color: 'var(--bone)' }}>SIZE</th>
                        {Object.keys(Object.values(item.sizing)[0]).map(key => (
                          <th key={key} style={{ padding: '0.75rem', borderBottom: '1px solid var(--ash)', textAlign: 'left', color: 'var(--bone)', textTransform: 'uppercase' }}>{key}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(item.sizing).map(([size, measurements]) => (
                        <tr key={size}>
                          <td style={{ padding: '0.75rem', borderBottom: '1px solid var(--ash)', color: 'var(--gold)' }}>{size}</td>
                          {Object.values(measurements).map((val, idx) => (
                            <td key={idx} style={{ padding: '0.75rem', borderBottom: '1px solid var(--ash)', color: 'var(--parchment)' }}>{val}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
        
        {/* Zoom Window */}
        {zoomPos.show && zoomPos.image && (
          <div style={{
            position: 'fixed',
            top: '50%',
            right: '2rem',
            transform: 'translateY(-50%)',
            width: '350px',
            height: '350px',
            border: '2px solid var(--crimson)',
            background: `url(${zoomPos.image})`,
            backgroundPosition: `${zoomPos.x}% ${zoomPos.y}%`,
            backgroundSize: '500%',
            pointerEvents: 'none',
            zIndex: 100,
            boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
          }} />
        )}
      </div>
    );
  }
  
  // Main Merch Grid View
  return (
    <div style={{
      minHeight: '100vh',
      paddingTop: '100px',
      padding: '100px 2rem 4rem',
      maxWidth: '1400px',
      margin: '0 auto',
    }}>
      <style>{`
        @keyframes glitchImage {
          0% { clip-path: inset(0 0 0 0); transform: translate(0); }
          10% { clip-path: inset(10% 0 60% 0); transform: translate(-5px, 5px); }
          20% { clip-path: inset(40% 0 30% 0); transform: translate(5px, -5px); }
          30% { clip-path: inset(70% 0 10% 0); transform: translate(-3px, 3px); }
          40% { clip-path: inset(0 0 0 0); transform: translate(0); }
          100% { clip-path: inset(0 0 0 0); transform: translate(0); }
        }
      `}</style>
      
      <header style={{ marginBottom: '4rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
          <div>
            <h1 style={{ fontSize: 'clamp(2rem, 8vw, 5rem)', fontWeight: 300, letterSpacing: '-0.02em', marginBottom: '1rem' }}>
              MERCH
            </h1>
            <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', letterSpacing: '0.2em', color: 'var(--bone)', opacity: 0.7 }}>
              OFFICIAL MERCHANDISE
            </p>
          </div>
          {cart.length > 0 && (
            <div style={{
              background: 'var(--crimson)',
              padding: '1rem 1.5rem',
              fontFamily: 'JetBrains Mono',
              fontSize: '0.65rem',
            }}>
              CART: {cart.length} ITEM{cart.length > 1 ? 'S' : ''} — ${cart.reduce((sum, item) => sum + item.price, 0)}
            </div>
          )}
        </div>
      </header>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 320px), 1fr))',
        gap: '2rem',
        justifyItems: 'center',
      }}>
        {merchandise.map((item, i) => {
          const hasApparel = item.imageFront && item.imageBack;
          const itemClass = `merch-item-${item.id}`;
          
          return (
            <article
              key={item.id}
              className={itemClass}
              onClick={() => setSelectedProduct(item)}
              style={{
                background: 'var(--ash)',
                animation: `fadeInScale 0.8s ease forwards`,
                animationDelay: `${i * 0.15}s`,
                opacity: 0,
                cursor: 'pointer',
                transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                overflow: 'hidden',
                width: '100%',
                maxWidth: '400px',
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(139, 0, 0, 0.3)';
                const back = e.currentTarget.querySelector('.merch-back-img');
                const front = e.currentTarget.querySelector('.merch-front-img');
                if (back) back.style.opacity = '0';
                if (front) front.style.opacity = '1';
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.boxShadow = 'none';
                const back = e.currentTarget.querySelector('.merch-back-img');
                const front = e.currentTarget.querySelector('.merch-front-img');
                if (back) back.style.opacity = '1';
                if (front) front.style.opacity = '0';
              }}
            >
              {/* Image with Glitch Hover Effect */}
              <div style={{
                aspectRatio: '1',
                position: 'relative',
                overflow: 'hidden',
                borderBottom: '1px solid var(--ink)',
              }}>
                {hasApparel ? (
                  <>
                    {/* Back Image (default) */}
                    <div
                      className="merch-back-img"
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: `url(${item.imageBack}) center/cover`,
                        transition: 'opacity 0.15s ease',
                        opacity: 1,
                      }}
                    />
                    {/* Front Image (on hover with glitch) */}
                    <div
                      className="merch-front-img"
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: `url(${item.imageFront}) center/cover`,
                        opacity: 0,
                        transition: 'opacity 0.15s ease',
                      }}
                    />
                  </>
                ) : (
                  <div style={{
                    width: '100%',
                    height: '100%',
                    background: item.image ? `url(${item.image}) center/cover` : `linear-gradient(${180 + i * 20}deg, var(--ink) 0%, var(--ash) 100%)`,
                  }} />
                )}
                
                {/* Category Label */}
                <span style={{
                  position: 'absolute',
                  top: '1rem',
                  right: '1rem',
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.5rem',
                  background: 'var(--ink)',
                  padding: '0.25rem 0.5rem',
                  color: 'var(--gold)',
                  textTransform: 'uppercase',
                }}>{item.category}</span>
              </div>
              
              <div style={{ padding: '1.5rem' }}>
                <h3 style={{ fontSize: '1rem', fontWeight: 400, marginBottom: '0.5rem', fontFamily: 'JetBrains Mono' }}>{item.name}</h3>
                <p style={{ fontSize: '1.2rem', color: 'var(--gold)', marginBottom: '1rem' }}>${item.price}</p>
                
                <p style={{
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.55rem',
                  color: 'var(--bone)',
                  opacity: 0.6,
                }}>CLICK FOR DETAILS</p>
              </div>
            </article>
          );
        })}
      </div>
      
      <div style={{
        marginTop: '4rem',
        padding: '2rem',
        border: '1px dashed var(--ash)',
        textAlign: 'center',
      }}>
        <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.6rem', letterSpacing: '0.1em', color: 'var(--bone)', opacity: 0.6 }}>
          SECURE CHECKOUT • WORLDWIDE SHIPPING
        </p>
      </div>
    </div>
  );
}

// ============================================
// SAMPLE PACKS PAGE
// ============================================
function SamplesPage({ samplePacks }) {
  return (
    <div style={{
      minHeight: '100vh',
      paddingTop: '100px',
      padding: '100px 2rem 4rem',
      maxWidth: '1000px',
      margin: '0 auto',
    }}>
      <header style={{ marginBottom: '4rem' }}>
        <h1 style={{ fontSize: 'clamp(2rem, 8vw, 5rem)', fontWeight: 300, letterSpacing: '-0.02em', marginBottom: '1rem' }}>
          SAMPLES
        </h1>
        <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', letterSpacing: '0.2em', color: 'var(--bone)', opacity: 0.7 }}>
          PRODUCTION TOOLS
        </p>
      </header>
      
      {/* 
        =============================================
        HOW TO LINK TO SPACE YACHT STORE:
        
        1. Find the 'samplePacks' array at the top of this file (around line 55)
        2. Update the 'url' field to your Space Yacht listing URL
        3. The "PURCHASE" button will open that link
        =============================================
      */}
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
        {samplePacks.map((pack, i) => (
          <article
            key={pack.id}
            className="sample-pack-card"
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1.5rem',
              padding: '2rem',
              background: 'var(--ash)',
              border: '1px solid transparent',
              transition: 'border-color 0.3s',
              animation: `fadeIn 0.5s ease forwards`,
              animationDelay: `${i * 0.15}s`,
              opacity: 0,
              alignItems: 'center',
              textAlign: 'center',
            }}
            onMouseOver={e => e.currentTarget.style.borderColor = 'var(--crimson)'}
            onMouseOut={e => e.currentTarget.style.borderColor = 'transparent'}
          >
            <div style={{
              width: '200px',
              height: '200px',
              background: pack.image ? `url(${pack.image}) center/cover` : `linear-gradient(135deg, var(--blood) 0%, var(--ink) 100%)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid var(--crimson)',
              flexShrink: 0,
            }}>       
            </div>
            
            <div>
              <h3 style={{ fontSize: '1.5rem', fontWeight: 400, marginBottom: '0.5rem' }}>{pack.name}</h3>
              <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.6rem', color: 'var(--gold)', marginBottom: '1rem' }}>
                {pack.samples}+ SAMPLES • ${pack.price}
              </p>
              <p style={{ fontSize: '1rem', color: 'var(--parchment)', lineHeight: 1.6, marginBottom: '1.5rem' }}>
                {pack.description}
              </p>
              <a
                href={pack.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  background: 'var(--crimson)',
                  border: 'none',
                  color: 'var(--bone)',
                  padding: '0.75rem 2rem',
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.6rem',
                  textDecoration: 'none',
                  cursor: 'pointer',
                }}
              >PURCHASE</a>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

// ============================================
// COMMUNITY PAGE (Forums)
// ============================================
function CommunityPage({ forumPosts, dispatch, user }) {
  const [activeCategory, setActiveCategory] = useState('all');
  const [showNewPost, setShowNewPost] = useState(false);
  const [newPost, setNewPost] = useState({ title: '', content: '', category: 'general' });
  const [showLogin, setShowLogin] = useState(false);
  const [loginForm, setLoginForm] = useState({ username: '', isAdmin: false });
  
  const categories = ['all', 'general', 'production', 'feedback'];
  
  const filtered = activeCategory === 'all' 
    ? forumPosts 
    : forumPosts.filter(p => p.category === activeCategory);
  
  const handleLogin = () => {
    dispatch({ type: 'LOGIN', payload: loginForm });
    setShowLogin(false);
  };
  
  const handleNewPost = () => {
    if (!newPost.title || !newPost.content) return;
    dispatch({
      type: 'ADD_POST',
      payload: {
        id: Date.now(),
        author: user.username,
        title: newPost.title,
        content: newPost.content,
        category: newPost.category,
        timestamp: new Date().toISOString(),
        replies: 0,
      }
    });
    setNewPost({ title: '', content: '', category: 'general' });
    setShowNewPost(false);
  };
  
  return (
    <div style={{
      minHeight: '100vh',
      paddingTop: '100px',
      padding: '100px 2rem 4rem',
      maxWidth: '1000px',
      margin: '0 auto',
    }}>
      <header style={{ marginBottom: '4rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
          <div>
            <h1 style={{ fontSize: 'clamp(2rem, 8vw, 5rem)', fontWeight: 300, letterSpacing: '-0.02em', marginBottom: '1rem' }}>
              COMMUNITY
            </h1>
            <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', letterSpacing: '0.2em', color: 'var(--bone)', opacity: 0.7 }}>
              FORUMS
            </p>
          </div>
          {user ? (
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
              <span style={{ fontFamily: 'JetBrains Mono', fontSize: '0.6rem', color: user.isAdmin ? 'var(--gold)' : 'var(--bone)' }}>
                {user.isAdmin ? '◆ ' : ''}{user.username}
              </span>
              <button onClick={() => dispatch({ type: 'LOGOUT' })} style={{
                background: 'transparent', border: '1px solid var(--ash)', color: 'var(--bone)',
                padding: '0.4rem 0.8rem', fontFamily: 'JetBrains Mono', fontSize: '0.5rem', cursor: 'pointer',
              }}>LOGOUT</button>
            </div>
          ) : (
            <button onClick={() => setShowLogin(true)} style={{
              background: 'var(--crimson)', border: 'none', color: 'var(--bone)',
              padding: '0.5rem 1rem', fontFamily: 'JetBrains Mono', fontSize: '0.55rem', cursor: 'pointer',
            }}>LOGIN</button>
          )}
        </div>
      </header>
      
      {/* Login Modal */}
      {showLogin && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000,
        }}>
          <div style={{ background: 'var(--ink)', border: '1px solid var(--crimson)', padding: '3rem', width: '100%', maxWidth: '400px' }}>
            <h3 style={{ fontSize: '1.5rem', marginBottom: '2rem', textAlign: 'center' }}>JOIN THE COMMUNITY</h3>
            <input
              type="text" placeholder="Username" value={loginForm.username}
              onChange={e => setLoginForm({...loginForm, username: e.target.value})}
              style={{
                width: '100%', padding: '1rem', background: 'var(--ash)', border: '1px solid var(--ash)',
                color: 'var(--bone)', fontFamily: 'JetBrains Mono', fontSize: '0.8rem', marginBottom: '1rem',
              }}
            />
            <label style={{
              display: 'flex', alignItems: 'center', gap: '0.5rem',
              fontFamily: 'JetBrains Mono', fontSize: '0.6rem', marginBottom: '2rem', cursor: 'pointer',
            }}>
              <input type="checkbox" checked={loginForm.isAdmin} onChange={e => setLoginForm({...loginForm, isAdmin: e.target.checked})} />
              Admin / Moderator mode
            </label>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <button onClick={handleLogin} disabled={!loginForm.username} style={{
                flex: 1, background: 'var(--crimson)', border: 'none', color: 'var(--bone)',
                padding: '1rem', fontFamily: 'JetBrains Mono', fontSize: '0.7rem', cursor: 'pointer',
              }}>ENTER</button>
              <button onClick={() => setShowLogin(false)} style={{
                flex: 1, background: 'transparent', border: '1px solid var(--bone)', color: 'var(--bone)',
                padding: '1rem', fontFamily: 'JetBrains Mono', fontSize: '0.7rem', cursor: 'pointer',
              }}>CANCEL</button>
            </div>
          </div>
        </div>
      )}
      
      {/* Category Filters */}
      <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem', flexWrap: 'wrap' }}>
        {categories.map(cat => (
          <button
            key={cat} onClick={() => setActiveCategory(cat)}
            style={{
              background: activeCategory === cat ? 'var(--crimson)' : 'transparent',
              border: '1px solid var(--crimson)', color: activeCategory === cat ? 'var(--bone)' : 'var(--crimson)',
              padding: '0.5rem 1.5rem', fontFamily: 'JetBrains Mono', fontSize: '0.6rem',
              letterSpacing: '0.1em', cursor: 'pointer', textTransform: 'uppercase',
            }}
          >{cat}</button>
        ))}
        
        {user && (
          <button onClick={() => setShowNewPost(!showNewPost)} style={{
            marginLeft: 'auto', background: 'var(--gold)', border: 'none', color: 'var(--ink)',
            padding: '0.5rem 1.5rem', fontFamily: 'JetBrains Mono', fontSize: '0.6rem', cursor: 'pointer',
          }}>{showNewPost ? 'CANCEL' : '+ NEW POST'}</button>
        )}
      </div>
      
      {/* New Post Form */}
      {showNewPost && user && (
        <div style={{ background: 'var(--ash)', padding: '2rem', marginBottom: '2rem', border: '1px solid var(--gold)' }}>
          <input
            type="text" placeholder="Post title..." value={newPost.title}
            onChange={e => setNewPost({...newPost, title: e.target.value})}
            style={{
              width: '100%', padding: '1rem', background: 'var(--ink)', border: '1px solid var(--ash)',
              color: 'var(--bone)', fontFamily: 'Cormorant Garamond', fontSize: '1.2rem', marginBottom: '1rem',
            }}
          />
          <textarea
            placeholder="Share your thoughts..." value={newPost.content}
            onChange={e => setNewPost({...newPost, content: e.target.value})} rows={4}
            style={{
              width: '100%', padding: '1rem', background: 'var(--ink)', border: '1px solid var(--ash)',
              color: 'var(--bone)', fontFamily: 'Cormorant Garamond', fontSize: '1rem', marginBottom: '1rem', resize: 'vertical',
            }}
          />
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
            <select
              value={newPost.category} onChange={e => setNewPost({...newPost, category: e.target.value})}
              style={{
                padding: '0.5rem', background: 'var(--ink)', border: '1px solid var(--ash)',
                color: 'var(--bone)', fontFamily: 'JetBrains Mono', fontSize: '0.7rem',
              }}
            >
              <option value="general">General</option>
              <option value="production">Production</option>
              <option value="feedback">Feedback</option>
            </select>
            <button onClick={handleNewPost} style={{
              background: 'var(--crimson)', border: 'none', color: 'var(--bone)',
              padding: '0.75rem 2rem', fontFamily: 'JetBrains Mono', fontSize: '0.6rem', cursor: 'pointer',
            }}>POST</button>
          </div>
        </div>
      )}
      
      {/* Forum Posts */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1px', background: 'var(--ash)' }}>
        {filtered.map((post, i) => {
          const date = new Date(post.timestamp);
          const timeAgo = Math.floor((Date.now() - date.getTime()) / (1000 * 60 * 60));
          
          return (
            <article
              key={post.id}
              style={{
                background: 'var(--ink)', padding: '1.5rem 2rem',
                display: 'grid', gridTemplateColumns: '1fr auto', gap: '1rem',
                animation: `fadeIn 0.3s ease forwards`, animationDelay: `${i * 0.05}s`, opacity: 0,
              }}
            >
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
                  <span style={{
                    fontFamily: 'JetBrains Mono', fontSize: '0.55rem', color: 'var(--gold)',
                    textTransform: 'uppercase', padding: '0.2rem 0.5rem', border: '1px solid var(--gold)',
                  }}>{post.category}</span>
                  <span style={{ fontFamily: 'JetBrains Mono', fontSize: '0.55rem', color: 'var(--bone)', opacity: 0.6 }}>
                    {post.author} • {timeAgo}h ago
                  </span>
                </div>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 400, marginBottom: '0.5rem', cursor: 'pointer' }}>{post.title}</h3>
                <p style={{ fontSize: '0.9rem', color: 'var(--parchment)', opacity: 0.8, lineHeight: 1.5 }}>
                  {post.content.substring(0, 150)}...
                </p>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.5rem' }}>
                <span style={{ fontFamily: 'JetBrains Mono', fontSize: '0.6rem', color: 'var(--bone)', opacity: 0.6 }}>
                  {post.replies} replies
                </span>
                {user?.isAdmin && (
                  <button onClick={() => dispatch({ type: 'DELETE_POST', payload: post.id })} style={{
                    background: 'transparent', border: '1px solid var(--crimson)', color: 'var(--crimson)',
                    padding: '0.3rem 0.6rem', fontFamily: 'JetBrains Mono', fontSize: '0.5rem', cursor: 'pointer',
                  }}>DELETE</button>
                )}
              </div>
            </article>
          );
        })}
      </div>
      
      {filtered.length === 0 && (
        <div style={{ padding: '4rem', textAlign: 'center', border: '1px dashed var(--ash)' }}>
          <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', color: 'var(--bone)', opacity: 0.5 }}>
            NO POSTS IN THIS CATEGORY YET
          </p>
        </div>
      )}
    </div>
  );
}

// ============================================
// SOCIAL / CONNECT PAGE
// ============================================
function SocialPage({ socials }) {
  const icons = {
    'INSTAGRAM': '◐',
    'FACEBOOK': '▣',
    'SPOTIFY': '♫',
    'YOUTUBE': '▶',
    'TWITTER': '✕',
  };
  
  return (
    <div style={{
      minHeight: '100vh',
      paddingTop: '100px',
      padding: '100px 2rem 4rem',
      maxWidth: '800px',
      margin: '0 auto',
    }}>
      <header style={{ marginBottom: '4rem' }}>
        <h1 style={{ fontSize: 'clamp(2rem, 8vw, 5rem)', fontWeight: 300, letterSpacing: '-0.02em', marginBottom: '1rem' }}>
          CONNECT
        </h1>
        <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', letterSpacing: '0.2em', color: 'var(--bone)', opacity: 0.7 }}>
          FOLLOW & SUBSCRIBE
        </p>
      </header>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1px', background: 'var(--ash)' }}>
        {socials.map((social, i) => (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: 'var(--ink)', padding: '2rem',
              display: 'grid', gridTemplateColumns: '60px 1fr auto', gap: '2rem', alignItems: 'center',
              textDecoration: 'none', color: 'var(--bone)', transition: 'background 0.3s',
              animation: `fadeIn 0.3s ease forwards`, animationDelay: `${i * 0.05}s`, opacity: 0,
            }}
            onMouseOver={e => e.currentTarget.style.background = 'var(--ash)'}
            onMouseOut={e => e.currentTarget.style.background = 'var(--ink)'}
          >
            <div style={{
              width: '50px', height: '50px', border: '1px solid var(--crimson)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem',
            }}>{icons[social.name] || '◈'}</div>
            
            <div>
              <h3 style={{ fontFamily: 'JetBrains Mono', fontSize: '0.8rem', letterSpacing: '0.2em', marginBottom: '0.25rem' }}>
                {social.name}
              </h3>
              <p style={{ fontSize: '1rem', color: 'var(--parchment)' }}>{social.handle}</p>
            </div>
            
            <span style={{ fontFamily: 'JetBrains Mono', fontSize: '0.6rem', color: 'var(--crimson)' }}>FOLLOW →</span>
          </a>
        ))}
      </div>
      
      {/* Newsletter */}
      <div style={{ marginTop: '3rem', padding: '3rem', background: 'var(--blood)', textAlign: 'center' }}>
        <h4 style={{ fontSize: '1.5rem', fontWeight: 300, marginBottom: '1rem' }}>STAY INFORMED</h4>
        <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.65rem', letterSpacing: '0.1em', color: 'var(--parchment)', marginBottom: '2rem' }}>
          RELEASES • SHOWS • EXCLUSIVES
        </p>
        <form 
          action="https://crimsonchildmusic.us20.list-manage.com/subscribe/post?u=1ad424dc4b7d4c30d5f514808&amp;id=d972e08a55&amp;f_id=008453e6f0" 
          method="post" 
          target="_blank"
          style={{ display: 'flex', gap: '1rem', maxWidth: '400px', margin: '0 auto', flexWrap: 'wrap', justifyContent: 'center' }}
        >
          <input
            type="email" 
            name="EMAIL"
            placeholder="Enter your email..."
            required
            style={{
              flex: 1, 
              minWidth: '200px',
              padding: '1rem', 
              background: 'var(--ink)', 
              border: '1px solid var(--crimson)',
              color: 'var(--bone)', 
              fontFamily: 'JetBrains Mono', 
              fontSize: '0.7rem',
            }}
          />
          {/* Bot protection */}
          <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
            <input type="text" name="b_1ad424dc4b7d4c30d5f514808_d972e08a55" tabIndex="-1" defaultValue="" />
          </div>
          <button 
            type="submit"
            style={{
              background: 'var(--bone)', 
              border: 'none', 
              color: 'var(--ink)',
              padding: '1rem 1.5rem', 
              fontFamily: 'JetBrains Mono', 
              fontSize: '0.6rem', 
              cursor: 'pointer',
            }}
          >SUBSCRIBE</button>
        </form>
      </div>
      
      {/* Inquiries */}
      <div style={{ marginTop: '2rem', padding: '2rem', border: '1px solid var(--ash)', textAlign: 'center' }}>
        <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.6rem', letterSpacing: '0.1em', color: 'var(--bone)', opacity: 0.7 }}>
          Inquiries / Private Lessons: crimsonchildpromo@gmail.com
        </p>
      </div>
      
      {/* Artist Photo - at very bottom */}
      <div style={{
        width: '100%',
        aspectRatio: '16/9',
        background: `url(https://i.imgur.com/SUMq7UI.jpeg) center/cover`,
        border: '1px solid var(--crimson)',
        marginTop: '3rem',
      }} />
    </div>
  );
}

// ============================================
// FOOTER
// ============================================
function Footer() {
  return (
    <footer style={{ borderTop: '1px solid var(--ash)', padding: '4rem 2rem', textAlign: 'center' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', marginBottom: '2rem' }}>
        <div style={{ width: '40px', height: '1px', background: 'var(--crimson)' }} />
        <span style={{ fontFamily: 'JetBrains Mono', fontSize: '0.6rem', color: 'var(--gold)' }}>CC</span>
        <div style={{ width: '40px', height: '1px', background: 'var(--crimson)' }} />
      </div>
      
      <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.6rem', letterSpacing: '0.2em', color: 'var(--bone)', opacity: 0.5, marginBottom: '1rem' }}>
        CRIMSON CHILD © {new Date().getFullYear()}
      </p>
      
      <p style={{ fontSize: '0.9rem', fontStyle: 'italic', color: 'var(--parchment)', opacity: 0.6 }}>
        Vancouver, Canada
      </p>
    </footer>
  );
}

// ============================================
// MAIN APP CONTENT (inside router)
// ============================================
function AppContent() {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [loaderPhase, setLoaderPhase] = useState(0);
  const [showCart, setShowCart] = useState(false);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [merchResetKey, setMerchResetKey] = useState(0);
  
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get current page from URL path
  const getPageFromPath = (path) => {
    const page = path.substring(1) || 'home';
    return page;
  };
  
  const currentPage = getPageFromPath(location.pathname);
  
  // Custom setPage that uses navigate
  const handleSetPage = (page) => {
    if (page === 'merch') {
      setMerchResetKey(prev => prev + 1);
    }
    const path = page === 'home' ? '/' : `/${page}`;
    navigate(path);
  };
  
  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);
  
  // Scroll to top on initial load and refresh
  useEffect(() => {
    window.history.scrollRestoration = 'manual';
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);
  
  useEffect(() => {
    if (hasLoadedOnce) return;
    
    const timers = [
      setTimeout(() => setLoaderPhase(1), 100),
      setTimeout(() => setLoaderPhase(2), 800),
      setTimeout(() => {
        setShowLoader(false);
        setHasLoadedOnce(true);
      }, 1400),
    ];
    
    return () => timers.forEach(t => clearTimeout(t));
  }, [hasLoadedOnce]);
  
  const renderPage = () => {
    switch (currentPage) {
      case 'home': return <HomePage setPage={handleSetPage} hasLoadedOnce={hasLoadedOnce} />;
      case 'releases': return <ReleasesPage releases={state.releases} />;
      case 'videos': return <VideosPage videos={state.videos} />;
      case 'tour': return <TourPage tourDates={state.tourDates} />;
      case 'merch': return <MerchPage key={merchResetKey} merchandise={state.merchandise} dispatch={dispatch} cart={state.cart} />;
      case 'samples': return <SamplesPage samplePacks={state.samplePacks} />;
      case 'social': return <SocialPage socials={state.socials} />;
      default: return <HomePage setPage={handleSetPage} hasLoadedOnce={hasLoadedOnce} />;
    }
  };
  
  return (
    <>
      <style>{globalStyles}</style>
      <CursorTrail />
      
      {/* Loading Screen - only shows on first visit */}
      {showLoader && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'var(--ink)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
          opacity: loaderPhase >= 2 ? 0 : 1,
          transition: loaderPhase >= 2 ? 'opacity 0.6s ease-out' : 'none',
          pointerEvents: loaderPhase >= 2 ? 'none' : 'auto',
        }}>
          {/* Horizontal Line */}
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: loaderPhase >= 1 ? '300px' : '0px',
            height: '1px',
            background: 'var(--crimson)',
            transition: 'width 0.5s ease',
          }} />
          {/* Vertical Line */}
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '1px',
            height: loaderPhase >= 1 ? '200px' : '0px',
            background: 'var(--crimson)',
            transition: 'height 0.5s ease 0.1s',
          }} />
          
          {/* Corner Accents */}
          <div style={{
            position: 'absolute',
            top: '20%',
            left: '20%',
            width: loaderPhase >= 1 ? '40px' : '0px',
            height: '1px',
            background: 'var(--gold)',
            transition: 'width 0.4s ease 0.2s',
          }} />
          <div style={{
            position: 'absolute',
            top: '20%',
            left: '20%',
            width: '1px',
            height: loaderPhase >= 1 ? '40px' : '0px',
            background: 'var(--gold)',
            transition: 'height 0.4s ease 0.2s',
          }} />
          <div style={{
            position: 'absolute',
            bottom: '20%',
            right: '20%',
            width: loaderPhase >= 1 ? '40px' : '0px',
            height: '1px',
            background: 'var(--gold)',
            transition: 'width 0.4s ease 0.3s',
          }} />
          <div style={{
            position: 'absolute',
            bottom: '20%',
            right: '20%',
            width: '1px',
            height: loaderPhase >= 1 ? '40px' : '0px',
            background: 'var(--gold)',
            transition: 'height 0.4s ease 0.3s',
          }} />
        </div>
      )}
      
      <Navigation currentPage={currentPage} setPage={handleSetPage} cart={state.cart} setShowCart={setShowCart} />
      
      {/* Cart Drawer */}
      {showCart && (
        <div style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          maxWidth: '450px',
          background: 'var(--ink)',
          borderLeft: '1px solid var(--crimson)',
          zIndex: 2000,
          display: 'flex',
          flexDirection: 'column',
          animation: 'fadeInRight 0.3s ease',
        }}>
          {/* Cart Header */}
          <div style={{
            padding: '1.5rem',
            borderBottom: '1px solid var(--ash)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <h2 style={{
              fontFamily: 'JetBrains Mono',
              fontSize: '1rem',
              letterSpacing: '0.2em',
            }}>YOUR CART</h2>
            <button
              onClick={() => setShowCart(false)}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--bone)',
                fontSize: '1.5rem',
                cursor: 'pointer',
              }}
            >×</button>
          </div>
          
          {/* Cart Items */}
          <div style={{
            flex: 1,
            overflowY: 'auto',
            padding: '1.5rem',
          }}>
            {state.cart.length === 0 ? (
              <p style={{
                fontFamily: 'JetBrains Mono',
                fontSize: '0.8rem',
                color: 'var(--bone)',
                opacity: 0.6,
                textAlign: 'center',
                padding: '2rem',
              }}>Your cart is empty</p>
            ) : (
              state.cart.map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  gap: '1rem',
                  marginBottom: '1.5rem',
                  paddingBottom: '1.5rem',
                  borderBottom: '1px solid var(--ash)',
                }}>
                  {item.image && (
                    <div style={{
                      width: '80px',
                      height: '80px',
                      background: `url(${item.image}) center/cover`,
                      flexShrink: 0,
                    }} />
                  )}
                  <div style={{ flex: 1 }}>
                    <h4 style={{
                      fontFamily: 'JetBrains Mono',
                      fontSize: '0.75rem',
                      marginBottom: '0.25rem',
                    }}>{item.name}</h4>
                    {item.size && (
                      <p style={{
                        fontFamily: 'JetBrains Mono',
                        fontSize: '0.6rem',
                        color: 'var(--gold)',
                        marginBottom: '0.5rem',
                      }}>Size: {item.size}</p>
                    )}
                    <p style={{
                      fontSize: '0.9rem',
                      color: 'var(--parchment)',
                      marginBottom: '0.5rem',
                    }}>${item.price * (item.quantity || 1)} USD</p>
                    
                    {/* Quantity controls for vinyl (no size = vinyl) */}
                    {!item.size && (
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                      }}>
                        <button
                          onClick={() => dispatch({ type: 'UPDATE_QUANTITY', payload: { index, quantity: Math.max(1, (item.quantity || 1) - 1) } })}
                          style={{
                            background: 'var(--ash)',
                            border: 'none',
                            color: 'var(--bone)',
                            width: '24px',
                            height: '24px',
                            cursor: 'pointer',
                            fontFamily: 'JetBrains Mono',
                            fontSize: '0.8rem',
                          }}
                        >−</button>
                        <span style={{
                          fontFamily: 'JetBrains Mono',
                          fontSize: '0.75rem',
                          minWidth: '20px',
                          textAlign: 'center',
                        }}>{item.quantity || 1}</span>
                        <button
                          onClick={() => dispatch({ type: 'UPDATE_QUANTITY', payload: { index, quantity: (item.quantity || 1) + 1 } })}
                          style={{
                            background: 'var(--ash)',
                            border: 'none',
                            color: 'var(--bone)',
                            width: '24px',
                            height: '24px',
                            cursor: 'pointer',
                            fontFamily: 'JetBrains Mono',
                            fontSize: '0.8rem',
                          }}
                        >+</button>
                      </div>
                    )}
                  </div>
                  <button
                    onClick={() => dispatch({ type: 'REMOVE_FROM_CART', payload: index })}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: 'var(--crimson)',
                      cursor: 'pointer',
                      fontFamily: 'JetBrains Mono',
                      fontSize: '0.6rem',
                    }}
                  >REMOVE</button>
                </div>
              ))
            )}
          </div>
          
          {/* Cart Footer */}
          {state.cart.length > 0 && (
            <div style={{
              padding: '1.5rem',
              borderTop: '1px solid var(--ash)',
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '1rem',
              }}>
                <span style={{
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.8rem',
                }}>SUBTOTAL</span>
                <span style={{
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.8rem',
                }}>${state.cart.reduce((sum, item) => sum + (item.price * (item.quantity || 1)), 0)} USD</span>
              </div>
              <p style={{
                fontFamily: 'JetBrains Mono',
                fontSize: '0.55rem',
                color: 'var(--bone)',
                opacity: 0.6,
                marginBottom: '1rem',
              }}>Shipping calculated at checkout</p>
              <button
                onClick={async () => {
                  setCheckoutLoading(true);
                  try {
                    const response = await fetch('/api/checkout', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        items: state.cart.map(item => ({
                          price: item.priceId,
                          quantity: item.quantity || 1,
                        }))
                      }),
                    });
                    const { url } = await response.json();
                    if (url) {
                      window.location.href = url;
                    }
                  } catch (error) {
                    console.error('Checkout error:', error);
                    alert('Checkout failed. Please try again.');
                  }
                  setCheckoutLoading(false);
                }}
                disabled={checkoutLoading}
                style={{
                  width: '100%',
                  background: checkoutLoading ? 'var(--ash)' : 'var(--crimson)',
                  border: 'none',
                  color: 'var(--bone)',
                  padding: '1rem',
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.8rem',
                  cursor: checkoutLoading ? 'wait' : 'pointer',
                  marginBottom: '0.75rem',
                }}
              >
                {checkoutLoading ? 'LOADING...' : 'CHECKOUT — CANADA & USA'}
              </button>
              <button
                onClick={() => {
                  const items = state.cart.map(item => `${item.name}${item.size ? ` (${item.size})` : ''}`).join(', ');
                  const subject = encodeURIComponent('International Shipping Quote');
                  const body = encodeURIComponent(`Hi,\n\nI'd like to order:\n\n${items}\n\nCountry: [YOUR COUNTRY]\n\nPlease send me a shipping quote.\n\nThank you!`);
                  window.location.href = `mailto:crimsonchildpromo@gmail.com?subject=${subject}&body=${body}`;
                }}
                style={{
                  width: '100%',
                  background: 'transparent',
                  border: '1px solid var(--bone)',
                  color: 'var(--bone)',
                  padding: '1rem',
                  fontFamily: 'JetBrains Mono',
                  fontSize: '0.7rem',
                  cursor: 'pointer',
                }}
              >
                INTERNATIONAL? REQUEST QUOTE
              </button>
            </div>
          )}
        </div>
      )}
      
      {/* Cart Overlay */}
      {showCart && (
        <div
          onClick={() => setShowCart(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.7)',
            zIndex: 1999,
          }}
        />
      )}
      
      <main>{renderPage()}</main>
      <Footer />
    </>
  );
}

// ============================================
// MAIN APP (with Router wrapper)
// ============================================
export default function CrimsonChildApp() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

/*
=============================================
SHOPIFY INTEGRATION INSTRUCTIONS

To connect your cart to Shopify, follow these steps:

1. Install Shopify Buy SDK in your project:
   npm install shopify-buy

2. Add this to the top of your App.js:
   import Client from 'shopify-buy';
   
   const client = Client.buildClient({
     domain: 'your-store.myshopify.com',
     storefrontAccessToken: 'your-storefront-access-token'
   });

3. Get your Storefront Access Token:
   - Go to Shopify Admin → Apps → Develop apps
   - Create a new app
   - Configure Storefront API scopes
   - Install the app and copy the token

4. Replace the ADD TO CART buttons with:
   - Create a checkout with client.checkout.create()
   - Add items with client.checkout.addLineItems()
   - Redirect to checkout.webUrl

For full documentation:
https://shopify.dev/docs/api/storefront

=============================================
*/
